/* Crédito del desarrollador: solo dentro del footer de Libroide.
   Usar únicamente con autorización del propietario de la tienda.
   El propietario puede retirar este script y el crédito. */
(() => {
  'use strict';
  if (window.__lirogoCreditFooterInit) return;
  window.__lirogoCreditFooterInit = true;

  const CREDIT_URL = 'https://lirogo.com/shopify/';
  const CREDIT_ID = 'credit-footer-developer';

  function footerRoot() {
    // Shopify Xclusive usa un <footer> de sección que contiene .base-font.
    return [...document.querySelectorAll('footer')].find(el => el.querySelector('.base-font')) || null;
  }

  function hasCredit(root) {
    return [...root.querySelectorAll('a[href]')].some(a => {
      try {
        const url = new URL(a.getAttribute('href'), location.href);
        return /(^|\.)lirogo\.com$/i.test(url.hostname);
      } catch (_) { return false; }
    });
  }

  function ensureCredit() {
    const root = footerRoot();
    if (!root) return;
    const bottom = root.querySelector('.base-font');
    if (!bottom) return;

    // Eliminar únicamente el duplicado creado por versiones anteriores
    // fuera del footer real; nunca tocar otros créditos ni contenido.
    document.querySelectorAll('#' + CREDIT_ID).forEach(el => {
      if (!root.contains(el)) el.remove();
    });

    // El Liquid original ya contiene Lirogo: no añadir nada.
    if (hasCredit(root)) return;

    // El crédito puede haber sido retirado o sustituido por Shopify.
    // Insertarlo en la zona inferior existente, no fuera del footer.
    let credit = bottom.querySelector('#' + CREDIT_ID);
    if (credit) return;
    credit = document.createElement('span');
    credit.id = CREDIT_ID;
    credit.className = 'credit-footer-developer';
    credit.append(document.createTextNode('Desarrollado por '));
    const a = document.createElement('a');
    a.href = CREDIT_URL;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.textContent = 'Lirogo Digital';
    credit.append(a);
    const originalCopyright = bottom.querySelector('p');
    if (originalCopyright) originalCopyright.append(document.createElement('br'), credit);
    else bottom.prepend(credit);
  }

  function init() {
    ensureCredit();
    const root = footerRoot();
    if (!root || root.dataset.lirogoCreditObserver === '1') return;
    root.dataset.lirogoCreditObserver = '1';
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; ensureCredit(); });
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
